export const configs = {
    //ApiUrl: "https://localhost:5001/api/",
    //ApiUrl : "https://localhost:44338/api/",
    ApiUrl: "/api/",
    //ImageHost: "http://quickcollect.debugged.be",
    ImageHost: "https://www.quickcollect.be",
    vapidPublicKey: "BDceOs3CDecH_NaN70iU0mdj8G7aiOomIfz_2mWnK0ysAuSOACKcY-CCdby3IA9IYDrxEDfJTirARfslFveyJQk",
}